import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableHead, TableRow, Switch, FormControlLabel } from '@mui/material';
import api from '../../api';

const LeaveNHManage = ({ empId, showMsg }) => {
  const [nationalHolidays, setNationalHolidays] = useState([]);

  useEffect(() => {
    loadNationalHolidays();
  }, []);

  const loadNationalHolidays = async () => {
    try {
      const res = await api.get('/settings/national-holidays');
      setNationalHolidays(res.data);
    } catch (err) { console.error(err); }
  };

  const handleNhToggle = async (nhId) => {
    try {
      await api.put(`/settings/national-holidays/${nhId}/toggle`);
      showMsg("Status Updated!");
      loadNationalHolidays();
    } catch (err) { 
      showMsg(err.response?.data?.detail || "Failed", "error"); 
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>Manage National Holidays</Typography>
      <Table size="small">
        <TableHead sx={{ bgcolor: '#f5f5f5' }}>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {nationalHolidays.map(nh => {
            const isPast = new Date(nh.date) < new Date(new Date().toISOString().split('T')[0]);
            return (
              <TableRow key={nh.id}>
                <TableCell sx={{ fontWeight: 'bold', color: isPast ? 'text.secondary' : '#d32f2f' }}>{nh.date}</TableCell>
                <TableCell>{nh.name}</TableCell>
                <TableCell>
                  <FormControlLabel 
                    control={<Switch checked={nh.is_active} onChange={() => handleNhToggle(nh.id)} disabled={isPast} color="success" />} 
                    label={nh.is_active ? "Active" : "Disabled"} 
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default LeaveNHManage;